module.exports = __webpack_public_path__ + "fonts/Happy-Camper-Regular.woff";


//////////////////
// WEBPACK FOOTER
// ./fonts/Happy-Camper-Regular.woff
// module id = 35
// module chunks = 0